/* Ritter PDP: mobile sticky add-to-cart (mirrors the real button; no cart logic of its own). 2026-08-18 */
(function(){
  if (window.matchMedia('(min-width:769px)').matches) return;
  var form = document.querySelector('.product_form form, form[action*="/cart/add"]');
  var btn = document.querySelector('[data-add-to-cart-trigger], .button--add-to-cart');
  if (!form || !btn) return;
  var priceEl = document.querySelector('.modal_price .current_price .money');
  var wasEl = document.querySelector('.modal_price .was-price .money');
  var bar = document.createElement('div'); bar.className = 'rcro-sticky';
  bar.innerHTML = '<div><span class="rcro-sticky-price"></span><span class="rcro-sticky-was"></span></div><button type="button">Add to cart</button>';
  document.body.appendChild(bar);
  function sync(){
    bar.querySelector('.rcro-sticky-price').textContent = priceEl ? priceEl.textContent.trim() : '';
    bar.querySelector('.rcro-sticky-was').textContent = (wasEl && wasEl.textContent.trim()) ? wasEl.textContent.trim() : '';
    bar.querySelector('button').textContent = btn.disabled ? 'Sold out' : (btn.querySelector('.text') ? btn.querySelector('.text').textContent.trim() : 'Add to cart');
    bar.querySelector('button').disabled = btn.disabled;
  }
  bar.querySelector('button').addEventListener('click', function(){ btn.scrollIntoView({behavior:'smooth', block:'center'}); setTimeout(function(){ btn.click(); }, 350); });
  var io = new IntersectionObserver(function(es){ es.forEach(function(e){ bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); }); }, {threshold:0});
  io.observe(btn);
  new MutationObserver(sync).observe(document.querySelector('.modal_price') || document.body, {subtree:true, childList:true, characterData:true});
  sync();
})();
